'use strict';

const jquery = require('jquery');
const htmx = require('htmx.org').default;
const processInclude = require('base/util');
const { tabIdentity } = require('./utils/tabIdentity');

window.jQuery = jquery;
window.$ = jquery;
window.htmx = htmx;

// mcTab / CSRF hooks before any HTMX or jQuery AJAX — not inside document.ready
// (hx-trigger=load and early requests can outrun ready callbacks).
processInclude(require('amb/components/ajaxHandlers').ajaxHandlers);

$(document).ready(function () {
    if (tabIdentity.isTabIsolation()) {
        processInclude(require('./components/coordinator').coordinator);
    }

    processInclude(require('./components/menu'));
    processInclude(require('./components/sidebar'));
    processInclude(require('./components/selectedHondaCentre').selectedHondaCentre);
    processInclude(require('./components/collapse').default);
    processInclude(require('./components/modal').default);
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/clientSideValidation').clientSideValidation);
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('honda_cars_ecux/ecux/ecux'));
    require('honda_cars_ecux/utils/popupDragClose').initGlobalDragClose();

    // Icons are now managed via the Icon Directive, enabling full support for the Page Designer "Icon Editor."
    // This update remains fully backward-compatible with the existing icon injection script.
    // processInclude(require('honda_cars_ecux/components/icons'));
    processInclude(require('amb/components/ajaxHandlers').ajaxHandlers);
});

require('honda_cars_ecux/thirdParty/bootstrap');
require('honda_cars_ecux/components/spinner');

// Amblique Base
require('amb_base/directives');
const {compilerService} = require('amb_base/services/compiler.service');

setTimeout(() => compilerService.observe());
